import Sessions from "utils/Sessions";
import { createAsyncThunk } from "@reduxjs/toolkit";
import ApiService from "redux/ApiService/ApiService";

const getAllNotifications = createAsyncThunk("notifications-listing/api", async (param) => {
  const urlParam = param !== undefined ? param : "";
  const res = await ApiService.get(`notifications?${urlParam}`, {
    headers: { Authorization: `Bearer ${Sessions.userToken}` },
  })
    .then((r) => r)
    .catch((err) => err.response);
  return res;
});

export const getPoperNotifications = createAsyncThunk(
  "notifications-poper-listing/api",
  async () => {
    const res = await ApiService.get(`notifications`, {
      headers: { Authorization: `Bearer ${Sessions.userToken}` },
    })
      .then((r) => r)
      .catch((err) => err.response);
    return res;
  }
);

export const markAsRead = createAsyncThunk(
  "notifications-mark-as-read/api",
  async ({ id, isRead }) => {
    const res = await ApiService.patch(
      `notifications/recipient/${id}`,
      { isRead },
      {
        headers: { Authorization: `Bearer ${Sessions.userToken}` },
      }
    )
      .then((r) => r)
      .catch((err) => err.response);
    return res;
  }
);

export const markAllAsRead = createAsyncThunk("notifications-mark-all-as-read/api", async () => {
  const res = await ApiService.patch(
    `notifications/recipient/read-all`,
    {},
    {
      headers: { Authorization: `Bearer ${Sessions.userToken}` },
    }
  )
    .then((r) => r)
    .catch((err) => err.response);
  return res;
});

export default getAllNotifications;
